import { apiClient } from './api';
import type { NormalizedCustomerListItem, CustomerDetailResponse } from '@wooconnect/shared';

export interface CustomersResponse {
  items: NormalizedCustomerListItem[];
  total: number;
  page: number;
  perPage: number;
  totalPages: number;
}

interface CustomersFilters {
  page?: number;
  perPage?: number;
  search?: string;
}

export async function getCustomers(siteId: string, filters: CustomersFilters): Promise<CustomersResponse> {
  const params = new URLSearchParams();
  if (filters.page) params.set('page', String(filters.page));
  if (filters.perPage) params.set('perPage', String(filters.perPage));
  if (filters.search) params.set('search', filters.search);
  const res = await apiClient.get(`/sites/${siteId}/customers?${params}`);
  return res.data.data;
}

export async function getCustomer(siteId: string, customerId: number): Promise<CustomerDetailResponse> {
  const res = await apiClient.get(`/sites/${siteId}/customers/${customerId}`);
  return res.data.data;
}
